module.exports = __webpack_public_path__ + "img/heizhima.f9035d1d.jpg";